import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { APP_PATHS, SEARCH_LOCATIONS_TABLE_COLUMNS_CONFIG } from '@core/constants';
import { LocationModel } from '@core/models';
import { TableComponent } from '@custom-components/general/table/table.component';

@Component({
  selector: 'xemex-locations-content',
  imports: [TableComponent],
  templateUrl: './locations-content.component.html',
  styleUrl: './locations-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationsContentComponent {
  locations = input<LocationModel[]>([]);
  loading = input(false);

  protected readonly columns = SEARCH_LOCATIONS_TABLE_COLUMNS_CONFIG;

  protected readonly tableData = computed(() =>
    this.locations().map(location => {
      const row = location as unknown as Record<string, unknown>;
      return {
        ...row,
        address: [
          row['locationStreet'],
          row['locationStreetNumber'],
          row['locationStreetNumberAddition'],
        ]
          .filter(part => part != null && part !== '')
          .join(' '),
        // The search API returns `locationPostalcode`, the locations API `locationPostalCode`.
        postalCode: row['locationPostalcode'] ?? row['locationPostalCode'],
      };
    }),
  );

  protected readonly rowLink = (row: Record<string, unknown>) => [
    '/',
    APP_PATHS.Locations,
    `${row['locationId']}`,
  ];
}
